import { createContext, SetStateAction, Dispatch } from "react";

import { GenerateHomeQuotationServiceRequest } from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {
    /** Variable to save all info about FIRE quotation request, for generate quotation or requotations */
    quotationForm:                          GenerateHomeQuotationServiceRequest | undefined; //TODO: Revisar Interface
    setQuotationForm:                       Dispatch<SetStateAction<GenerateHomeQuotationServiceRequest | undefined>>;

    handleTabErrors:                        (errorFields: any[], tabPrefix: string[], tabName: string) => void;
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);